import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ScheduleService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: Http,
    private httpClient: HttpClient
  ) { }

  public getSchedule(date: string): any {
    const params = new HttpParams()
      .set('current-date', date);

    const url = this.urlPrefix + 'work-schedule';
    return this.httpClient
      .get(url, { params: params, observe: 'response'})
      .map (
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return null;
          }
        }
      )
      .catch (
        err => { return err; }
      )
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/schedule/schedule.service.ts